import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { WebengageService } from 'src/app/services/webengage.service';
import { environment } from 'src/environments/environment';
import { Casautomation } from 'src/app/services/casautomation.service';
import { switchMap, catchError, finalize } from 'rxjs/operators';
import { EMPTY, throwError } from 'rxjs';

declare let $: any;
declare function CallSmallCase(TranID: string,Token: string,cb:any): any;

export function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve();
    s.onerror = reject;
    document.body.appendChild(s);
  });
}
@Component({
  selector: 'app-casautomation',
  templateUrl: './casautomation.component.html',
  styleUrls: ['./casautomation.component.css']
})

export class CasautomationComponent implements OnInit {
  visitorId: any;
  leadId: string = '';
  error_msg: boolean = false;
  appRunnerUrl: string = '';

  meta_title: string = '';
  meta_desc: string = '';
  meta_keywords: string = '';
  otp: any = '';
  otpValidateMessage: string = '';
  generateotp: boolean = false;
  invalidOtpStatus: boolean = false;
  otpVerified: boolean = false;
  otpVerifiedFlag: boolean = false;
  isResendOTP: boolean = false;
  isButtonDisabled = false;
  nameValidateMessage: string = '';
  emailValidateMessage: any = '';
  mobileValidateMessage: any = '';
  pincodeValidateMessage: any = '';
  name: string = '';
  email: string = '';
  mobile: string = '';
  pan: string = '';
  showOtp: boolean = false;
  transactionId='';
  token='';
  authToken='';
  formLocked: boolean = false;
  otpTimer = 60;
  timerInterval: any;
  canResend = false;
  otpErrorMessage = '';
  successMessage = '';
  isSubmitting = false;
  errorMessage = '';
  loading = false;
  constructor(@Inject(DOCUMENT) private readonly document: Document, private readonly route: ActivatedRoute, private readonly smallCaseAPi: Casautomation, private readonly casService: DataService, private readonly webengageService: WebengageService, private readonly titleService: Title, private readonly metaService: Meta) { }

  ngOnInit(): void {
    // Async initialization wrapped in IIFE to avoid returning a Promise from ngOnInit (S6544)
    void (async () => {
      try {
        await Promise.all([
          loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.2.4/gsap.min.js'),
          loadScript('//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js')
        ]);
      } catch (e) {
        console.error('Failed to load GSAP/Slick scripts:', e);
      }

      $('#submitnewBtn').hide();
      window['appRunner'] = environment;
      this.appRunnerUrl = environment.appRunnerUrl;
      this.route.queryParams.subscribe(params => {
        if (params['error']) {
          this.error_msg = true;
        }
      });
      (window as any).createVisitor = this.createVisitor.bind(this);
      (window as any).CRMData1 = this.CRMData1.bind(this);
      (window as any).CRMData2 = this.CRMData2.bind(this);
      (window as any).CRMDataUpdate = this.CRMDataUpdate.bind(this);
      (window as any).webengageTrackUser = this.webengageTrackUser.bind(this);
      if (sessionStorage.getItem('visitorId')) {
        this.visitorId = '';
        sessionStorage.setItem('visitorId', '');
      }
      if (sessionStorage.getItem('found')) {
        sessionStorage.removeItem('found')
      }
      if (sessionStorage.getItem('message_date')) {
        sessionStorage.removeItem('message_date')
      }
      if (localStorage.getItem('file_url')) {
        localStorage.removeItem('file_url')
      }
      if (sessionStorage.getItem('leadId')) {
        this.leadId = '';
        sessionStorage.removeItem('leadId')
      }

      setTimeout(() => {
        // otp field manage
        let otpdiv = $('#otpdiv');
        let editnumber = $('#editnumber');
        let mobileDivId = $('div#mobile_number');
        let send_otp = $('#send_otp');

        $(send_otp).click(function () {
          $("#otpdiv").css({
            display: "block",
            opacity: 0,
            right: "-300px"
          }).animate({
            right: "0px",
            opacity: 1
          }, 500);
        })
        $(editnumber).click(function () {
          $(otpdiv).animate({ "opacity": "hide", right: "-400" }, 1000);
          $(mobileDivId).animate({ top: "0" }, 1000);
          $(mobileDivId).animate({ "opacity": "show", right: "0" }, 1000);
        })
      }, 200);

      document.getElementById('scrollButton')?.addEventListener('click', () => {
        const targetElement = document.getElementById('graph');
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.route.queryParams.subscribe((params) => {
        const messageDate = params['message_date'];
        const found = params['found'];
        if (found) {
          sessionStorage.setItem('found', found);
        }
        if (messageDate) {
          sessionStorage.setItem('message_date', messageDate);
        }
      });

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      const utm_found = urlParams.get('found');

      let msg1 = document.getElementById('msg1');
      let msg2 = document.getElementById('msg2');

      if (!utm_found) {
        $(msg1).removeClass('d-none');
        $(msg2).addClass('d-none');
      } else {
        $(msg2).removeClass('d-none');
        $(msg1).addClass('d-none');
      }

      setTimeout(() => {
        let gUrl = localStorage.getItem('file_url');
        $('#g_url').attr('href', gUrl);
      }, 1000)

      $('#whatsapp').parent().hide();
      let darktoggle = document.querySelectorAll(".dark-toggle");
      $(darktoggle).hide();

      let nanotab = document.querySelectorAll(".nanotab-wrapper");
      $(nanotab).hide();

      try {
        await loadScript('./assets/js/wealthmax/newotp.js');
      } catch (e) {
        console.error('Failed to load newotp.js:', e);
      }

      this.metaForSEO("wealthmax");
    })();
  }
  onlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow only digits (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text') || '';

    // Block if pasted content is not only numbers
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }
  onlyLetters(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow A-Z, a-z and space
    if (
      !(charCode >= 65 && charCode <= 90) && // A-Z
      !(charCode >= 97 && charCode <= 122) && // a-z
      charCode !== 32 // space
    ) {
      event.preventDefault();
    }
  }

  onPasteName(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text') || '';

    // Allow only letters and spaces
    if (!/^[A-Za-z ]+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }


  metaForSEO(slugname: string): void {
    this.casService.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];

        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;

            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err: any) => {
        console.error('Error fetching SEO metadata:', err);
      }
    );
  }

  scrollToTop(): void {
    $('html, body').animate({
      scrollTop: $('#Wmleadform').offset()?.top - 175
    }, 500);
  }

  numbersOnlyotp($event: any) {
    return /^[0-9]$/.test($event.key);
  };

  startOtpTimer() {
    this.otpTimer = 60;
    this.canResend = false;

    this.timerInterval = setInterval(() => {
      this.otpTimer--;

      if (this.otpTimer <= 0) {
        clearInterval(this.timerInterval);
        this.canResend = true;
      }
    }, 1000);
  }
  private getJwtToken(response: any): string {
    return response?.data?.token ||
      response?.data?.jwtToken ||
      response?.data?.accessToken ||
      response?.token ||
      response?.jwtToken ||
      response?.accessToken ||
      '';
  }

  formsubmit = false;
  generateOTP() {
    this.formsubmit = true;
    if (!this.pan || !this.mobile || !this.name || !this.email) return;
    this.errorMessage = '';
    this.successMessage = '';
    // show loader on submit button
    this.isSubmitting = true;
    this.loading = true;
    // this.formLocked = true;
    this.showOtp = false;

    const authPayload = {
      pan: this.pan,
      email: this.email,
      mobile: this.mobile
    };

    this.smallCaseAPi.generateTokenByPanEmail(authPayload).pipe(

      switchMap((authRes: any) => {
        this.authToken = this.getJwtToken(authRes);

        if (!this.authToken) {
          return throwError(() => new Error("Auth Token Missing"));
        }

        return this.smallCaseAPi.getFetchStatusMfCampaign({ pan: this.pan }, this.authToken);
      }),

      switchMap((statusRes: any) => {

        const fetchedStatus = statusRes?.data?.fetchedStatus;

        if (fetchedStatus === true) {
          this.successMessage =
            "Your query is already submitted. Our RM will contact you soon.";
          this.loading = false;
          this.formLocked = true;

          return throwError(() => new Error("Already Submitted"));
        }
        return this.smallCaseAPi.generateTokenSm(this.authToken);
      }),
      switchMap((tokenRes: any) => {
        this.token = tokenRes?.data?.token;
        const payload = {
          smallcaseToken: this.token,
          pan: this.pan,
          mobile: this.mobile
        }
        return this.smallCaseAPi.generateTransactionSm(payload, this.authToken);
      }),

      switchMap((transactionRes: any) => {
        this.transactionId = transactionRes?.data?.result?.transactionId;
        CallSmallCase(this.transactionId, this.token, () => {
          this.successMessage = "Your query has been submitted. Our RM will connect you soon...";

          const payload = {
            name: this.name,
            pan: this.pan,
            email: this.email,
            phone: this.mobile,
            transactionId: this.transactionId,
            source: "bcl_campaign_mf_lead"
          };

          this.smallCaseAPi.insertMfcampaignlead(payload, this.authToken).subscribe({
            next: (res: any) => {
              console.log("MF Campaign Lead inserted", res);
            },
            error: (err) => {
              console.error("Lead API failed", err);
            }
          });

        });
        
          return EMPTY;
      }),

      catchError((error) => {

        if (error.message === "Already Submitted") {
          return throwError(() => error);
        }

        this.formLocked = false;
        this.errorMessage = error.message === "Auth Token Missing"
          ? "Unable to authenticate this request. Please try again."
          : "Something went wrong. Please try again.";
        return throwError(() => error);
      }),

      finalize(() => {
        this.loading = false;
        // hide loader regardless of outcome
        this.isSubmitting = false;
        this.formLocked = false;
      })

    ).subscribe(() => {

      this.showOtp = true;
      this.startOtpTimer();

    });
  }

  verifyOtp() {
    if (!this.otp || this.otp.length !== 6) {
      this.invalidOtpStatus = true;
      return;
    }
    this.isSubmitting = true;
    this.invalidOtpStatus = false;
    this.otpErrorMessage = '';

    const verifyBody = {
      pan: this.pan,
      phone: this.mobile,
      transactionId: this.transactionId,
      otp: this.otp
    };
    this.smallCaseAPi.verifyOtpURL(verifyBody).pipe(
      catchError((err) => {
        this.invalidOtpStatus = true;
        this.otpErrorMessage = "Invalid OTP";
        return throwError(() => err);
      }),
      finalize(() => {
        this.isSubmitting = false;
      })
    ).subscribe((res: any) => {

      if (res?.success) {
        this.successMessage = "Your query has been summited Our Rm will connect you soon... ";
        this.showOtp = false;
      } else {
        this.invalidOtpStatus = true;
        this.otpErrorMessage = "Invalid OTP";
      }
    });
  }

  editNumber() {
    this.showOtp = false;
    this.formLocked = false;
    this.otp = '';
  }

  resendOTP() {
    if (!this.canResend) return;
    this.generateOTP();
  }

  submitForm() {
    if (this.otp.length === 6) {
      this.verifyOtp();
    }
  }

  convertPanToUppercase() {
    if (this.pan) {
      this.pan = this.pan.toUpperCase();
    }
  }


  removeErrorMsg(fieldname: string) {
    if (fieldname == "name") {
      this.nameValidateMessage = "";
    }
    if (fieldname == "mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname == "email") {
      this.emailValidateMessage = "";
    }
    if (fieldname == "otp") {
      this.otpValidateMessage = "";
    }
    if (fieldname == "pincode") {
      this.pincodeValidateMessage = "";
    }
  }

  createVisitor(name: string, email: string, mobile: string, callback: () => void): void {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '47',
        "visitortype": "wealthmax_cas_not_found",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.casService.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"]);
        // After createVisitor completes, call createLead and pass the callback
        this.createLead(name, email, mobile, callback);
      }, (err: any) => {
        throw err;
      })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId');
      this.createLead(name, email, mobile, callback);
    }
  }
  createLead(name: string, email: string, mobile: string, callback: () => void): void {
    let leadid = sessionStorage.getItem('leadId');
    let obj = {
      visitorid: this.visitorId,
      leadid: leadid || 0,
      name: name,
      mobile: mobile,
      email: email
    };
    this.casService.createLead(obj).subscribe(
      (data: any) => {
        sessionStorage.setItem('leadId', data['leadid']);
        this.leadId = data['leadid'];
        if (callback) {
          callback();
        }
      },
      (err: any) => {
        console.error('Error creating lead:', err);
      }
    );
  }
  GetParameterValues(param: string) {
    let url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (const element of url) {
      let urlparam = element.split('=');
      if (urlparam[0] == param) {
        return urlparam[1];
      }
    }
    return
  }

  CRMData1(name: string, email: string, mobile: string, callback?: () => void): void {
    let utm_source = this.GetParameterValues('utm_source');
    let utm_medium = this.GetParameterValues('utm_medium');
    let lead_source = this.GetParameterValues('lead_source');
    let utm_campaign = this.GetParameterValues('utm_campaign');
    this.casService
      .pushLeadToSF({
        Name: name,
        email: email,
        Mobile: mobile,
        LEADID: this.leadId,
        Campaign_Name: utm_campaign || 'wealthmax_cas_automation_lead',
        Product: 'Mutual Funds',
        Landing_Page_URL: window.location.href,
        LeadSource: lead_source || (utm_source || 'Website'),
        Utm_Source: utm_source || '',
        Utm_Medium: utm_medium || '',
        Utm_Campaign: utm_campaign || 'wealthmax_cas_automation_lead',
      })
      .subscribe(
        (data: any) => {
          sessionStorage.setItem('CRM_Id', data['data']['id']);
          this.CRMDataUpdate(mobile, 'User submitted the lead form.', 'false')
          this.CRMDataUpdate(mobile, 'Report fetch initiated.', 'false')
          // Call the callback after success
          if (callback) {
            callback();
          }
        },
        (error: any) => {
          console.error('CRMData Error:', error);
        }
      );
  }

  CRMData2(name: string, email: string, mobile: string, callback?: () => void): void {
    let utm_source = this.GetParameterValues('utm_source');
    let utm_medium = this.GetParameterValues('utm_medium');
    let lead_source = this.GetParameterValues('lead_source');
    let utm_campaign = this.GetParameterValues('utm_campaign');
    this.casService
      .pushLeadToSF({
        Name: name,
        email: email,
        Mobile: mobile,
        LEADID: this.leadId,
        Campaign_Name: utm_campaign || 'wealthmax_cas_not_found',
        Product: 'Mutual Funds',
        Landing_Page_URL: window.location.href,
        LeadSource: lead_source || utm_source || 'Website',
        Utm_Source: utm_source || '',
        Utm_Medium: utm_medium || '',
        Utm_Campaign: utm_campaign || 'wealthmax_cas_not_found',
      })
      .subscribe(
        (data: any) => {
          sessionStorage.setItem('CRM_Id', data['data']['id']);
          this.CRMDataUpdate(mobile, 'User submitted the lead form.', 'false')
          this.CRMDataUpdate(mobile, 'Report fetch initiated.', 'false')
          // Call the callback after success
          if (callback) {
            callback();
          }
        },
        (error: any) => {
          console.error('CRMData Error:', error);
        }
      );
  }


  CRMDataUpdate(mobile: string, remarks: string, redirect: string): void {
    let timestamp = this.getFormattedTimestamp()
    let CRM_Id = sessionStorage.getItem('CRM_Id')

    this.casService
      .updateCasLead({
        CRM_Id: CRM_Id,
        Mobile: mobile,
        Remarks: `${remarks} ${timestamp}`
      })
      .subscribe(
        (data: any) => {
        },
        (error: any) => {
          console.error('CRMData Error:', error);
        }
      );
  }

  webengageTrackUser(name: string, email: string, mob: string) {
    // webengage specific function
    let firstName = name.split(' ')[0];
    let lastName = name.split(' ')[1];
    let mobile = '91' + mob;

    this.casService.webengageEncrypt({ "id": mob }).subscribe((data: any) => {
      let encryptedMob = data["encryptData"]
      this.webengageService.webengageUserLogin(encryptedMob);
      this.webengageService.webengageTrackUser('we_first_name', firstName);
      if (lastName) {
        this.webengageService.webengageTrackUser('we_last_name', lastName);
      }
      this.webengageService.webengageTrackUser('we_email', email);
      this.webengageService.webengageTrackUser('we_phone', mobile);
      this.webengageService.webengageTrackUser('we_whatsapp_opt_in', true);
    });
  }


  closeError() {
    this.error_msg = false;
  }

  getFormattedTimestamp(): string {
    const now = new Date();

    const pad = (n: number) => n.toString().padStart(2, '0');

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear().toString().slice(-2);

    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  cancelMultipleUserPopup() {
    window.location.reload();
    sessionStorage.clear();
  }

  back() {
    this.document.getElementById('FNAME')!.style.display = 'none';
    this.document.getElementById('FEMAIL')!.style.display = 'none';
    this.document.getElementById('FCASPASS')!.style.display = 'none';
    this.document.getElementById('FMOB')!.style.display = 'none';
    this.document.getElementById('otpdivErrorDiv')!.style.display = 'none';
    this.document.getElementById('submitnewBtn')!.style.display = 'none';
    this.document.getElementById('otpdiv')!.style.display = 'none';




  }
}
